import { DataSources } from "@/models/Message";
import { Link, makeStyles, Text, tokens } from "@fluentui/react-components";
import React from "react";

type Props = {
  dataSources: DataSources;
};

export const DataSourceRAG: React.FC<Props> = ({ dataSources }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <Text className={classes.heading}>参照元</Text>
      <div className={classes.sourceListWrapper}>
        {dataSources.map((dataSource) => {
          return (
            <>
              <Link as="a" className={classes.sourceSection} href={dataSource.url} target="blank">
                {dataSource.title}
              </Link>
              <Text>{dataSource.section}</Text>
            </>
          );
        })}
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  wrapper: {},
  heading: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightBold,
  },
  sourceListWrapper: {
    marginTop: tokens.spacingVerticalXS,
    display: "grid",
    rowGap: tokens.spacingVerticalM,
    columnGap: tokens.spacingHorizontalM,
    alignItems: "start",
    gridTemplateColumns: "auto 1fr",
  },
  sourceSection: {
    display: "block",
    minWidth: "50px",
    verticalAlign: "top",
    wordBreak: "break-all",
  },
});
